// Dashboard.js
import React, { useState} from 'react';
import 'chartjs-adapter-date-fns';
import '@styles/Dashboard.css';
import PaginatedTable from '@components/PaginatedTable';
import ChartPanel from '@components/ChartPanel';
import BubbleChart from '@components/BubbleChart';

const Dashboard = () => {
  
  const [feedbackData, setFeedbackData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  const sortedFeedbackData = [...feedbackData].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    if (sortConfig.key === 'timestamp') {
      return sortConfig.direction === 'ascending'
        ? new Date(aValue) - new Date(bValue)
        : new Date(bValue) - new Date(aValue);
    }

    if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
    return 0;
  });

  return (
    <div className="container mt-5">
      <button className="btn btn-secondary" onClick={() => window.history.back()}>
  ← Back
</button>
      <h3 className="text-center">Feedback Table</h3>

      <div className="table-responsive">
        <PaginatedTable
        sortedFeedbackData={sortedFeedbackData}
        sortConfig = {sortConfig}
        setSortConfig={setSortConfig}
        feedbackData={feedbackData}
        />

        <ChartPanel
        setFeedbackData = {setFeedbackData}
        />

      </div>

      <BubbleChart/>
    
    </div>
  );
};

export default Dashboard;